<template>
  <div>
    <div class="sign-btn" v-if="!newUpdata">
      <!--    <div style="text-align: center;">-->
      <!--      <span class="add-btn"></span>-->
      <!--      <div class="add-text">-->
      <!--        <p class="title">文件发起签约</p>-->
      <!--        <p>（小于10M）</p>-->
      <!--      </div>-->
      <!--    </div>-->
      <!--    <p class="tip">支持pdf、jpg、png、bmp格式</p>-->
      <div style="padding-top: 20px">
        <div class="faqi">
          <img src="../../static/img/faqi.png"/>
          <p>文件发起签署</p>
        </div>
      </div>
      <p class="tip">(小于10M)</p>
      <p class="tip" style="padding-bottom: 20px">仅支持pdf格式</p>
      <input @change="handleInputChange($event)" type="file" accept="application/pdf" style="padding-top: 20px"/>
    </div>
    <div class="new-updata" v-if="newUpdata">
      <i class="el-icon-plus"></i>
      <input @change="handleInputChanges($event)" id="fileInput" title="" type="file" multiple="multiple"
             :accept='accept'/>
    </div>
  </div>
</template>

<script>
  import httpServer from '../http/http-server'

  export default {
    props: {
      size: {
        type: String,
        default: 'small'
      },
      filesList: {type: Number},
      imgIndex: {type: Number},
      newUpdata: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        loading: null,
        accept: '.pdf,.doc,.docx'

      }
    },
    methods: {
      // input内容change事件处理
      handleInputChange: function (e) {
        let file = e.target.files[0] || e.value
        const filename_arry = file.name.split('.')
        filename_arry.splice(filename_arry.length - 1, 1)
        let filename = filename_arry.join('.')
        // let re = new RegExp('(.jpg|.png|.bmp|.jpeg|.pdf)$', 'i');
        let re = new RegExp('(.pdf)$', 'i')

        if (!re.test(file.name)) {
          e.target.value = ''
          // return this.$message.warning('文件格式只能是jpg/png/bmp/pdf的文件');
          return this.$message.warning('文件格式只能是pdf的文件')
        }

        if (file.size > 1024 * 1024 * 10) {
          e.target.value = ''
          return this.$message.warning('文件大小不能超过10M')
        }

        this.uploadTempFile(file, filename)
        e.target.value = ''
      },
      //docx转为pdf
      checkPdf(files) {
        // let formData = new FormData()
        // formData.append('file', files)
        httpServer.tplcustomFile({file: files.data}).then(res => {

        })
      },

      // 多文件上传
      handleInputChanges(e) {
        const input = document.getElementById('fileInput');
        const fileList = input.files;

        for (const file of fileList) {
          const fileTypeFlag = /^.pdf|.doc|.docx$/.test(
            file.name.substring(file.name.lastIndexOf('.')).toLowerCase()
          )
          if (!fileTypeFlag) {
            this.$message.warning(
              '文件类型只能是.pdf,.dox,.docx'
            )

            return false
          }

        }
        // 如果所有文件都符合格式要求，则允许提交表单
        // return true;

        let files = e.target.files
        console.log(files, 'files')

        if (files.length > 10) {
          this.$message.error('最多同时上传10个材料')
          return
        }
        if (files.length > (10 - this.filesList)) {
          this.$message.error('最多上传10个材料')
          return
        }

        let promiseList = []
        let customFileList = []
        for (let i = 0; i < files.length; i++) {
          console.log(files[i], 'files[i]')
          let formData = new FormData()
          formData.append('file', files[i])
          const notPDF = /^.doc|.docx$/.test(
            files[i].name.substring(files[i].name.lastIndexOf('.')).toLowerCase()
          )
          if (notPDF) {
            promiseList[i] = httpServer.tplcustomFile(formData)
          } else {
            promiseList[i] = httpServer.upFile(formData)
          }


          customFileList.push({name: files[i].name.split()[0]})
        }

        Promise.all(promiseList).then(res => {
          if (res.every(item => item.success)) {
            this.getPdfsToImgs(res, customFileList)
          } else {
            this.$message.error('上传文件失败')
          }
        })
      },
      //  pdf转img
      getPdfsToImgs(files, customFileList) {
        let getImg = files.map((item, index) => {
          customFileList[index].fileId = item.data
          return httpServer.pdfToImg({fileId: item.data})
        })
        Promise.all(getImg).then(res => {
          if (res.every(item => item.success)) {
            res.forEach((item, index) => {
              customFileList[index].urls = item.data
            })
            this.$emit('imgList', customFileList)
            // this.$emit('tplText', id)
          } else {
            this.$message.error('上传文件失败')
          }
        })
      },
      // 上传临时合同文件
      uploadTempFile(file, fileName) {
        this.loadingStart()
        const fd = new FormData()
        fd.append('file', file)
        httpServer.upFile(fd).then(res => {
          if (res.success) {
            this.pdfToImg(res.data)
          } else {
            this.loadingClose()
            this.$message.error('上传合同失败')
          }
        }).catch(err => {
          this.loadingClose()
          this.$message.warning(err.description || '上传合同失败')
        })
      },
      pdfToImg(id) {
        httpServer.pdfToImg({fileId: id}).then(res => {
          if (res.success) {
            this.$emit('imgList', res.data, id, this.imgIndex)
            this.$emit('tplText', id)
          }
          this.loadingClose()
        })
      },
      loadingStart(info) {
        this.loading = this.$loading({
          lock: true,
          text: info || '正在上传合同',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, .5)'
        })
      },
      loadingClose() {
        if (this.loading) {
          this.loading.close()
          this.loading = null
        }
      }
    },
    name: 'publish-sign'
  }
</script>

<style lang="less" scoped>
  .sign-btn {
    width: 150px;
    margin: 10px auto;
    position: relative;
    /*margin-bottom: 10px;*/
    /*padding: 40px 10px;*/
    /*border: 1px dashed #EC1C1C;*/
    border-radius: 4px;

    &:hover {
      transition: all .3s ease;
      /*background-color: #f1f1f1;*/
    }

    .add-btn {
      position: relative;
      display: inline-block;
      vertical-align: middle;
      width: 40px;
      height: 40px;
      background-color: #fcd1d4;

      &:before {
        display: inline-block;
        content: '';
        width: 2px;
        left: 50%;
        top: 5%;
        margin-left: -1px;
        height: 90%;
        background-color: #ec1c1c;
        position: absolute;
        z-index: 1;
      }

      &:after {
        display: inline-block;
        content: '';
        height: 2px;
        width: 90%;
        left: 5%;
        top: 50%;
        margin-top: -1px;
        background-color: #ec1c1c;
        position: absolute;
      }
    }

    .add-text {
      display: inline-block;
      vertical-align: middle;
      margin: 0 28px;
      color: #7F7F7F;
      font-size: 14px;

      .title {
        color: #353535;
        font-size: 18px;
        font-weight: 600;
      }
    }

    .tip {
      margin-top: 15px;
      color: #525561;
      text-align: center;
      font-size: 14px;
    }

    input[type='file'] {
      position: absolute;
      z-index: 1;
      display: inline-block;
      width: 100%;
      height: 40px;
      left: 0;
      top: 0;
      cursor: pointer;
      opacity: 0;
    }
  }

  .faqi {
    background: #ED8E57;
    border-radius: 2px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 14px;
    padding: 10px;

    img {
      width: 20px;
    }
  }

  .new-updata {
    border-radius: 4px;
    border: 1px dashed #376eef;
    width: 90px;
    height: 65px;
    color: #376eef;
    text-align: center;
    line-height: 65px;
    position: relative;
    cursor: pointer;

    .el-icon-plus::before {
      font-size: 20px !important;
    }

    input {
      cursor: pointer;
      position: absolute;
      width: 90px;
      height: 65px;
      top: 0;
      left: 0;
      padding-top: 0;
      opacity: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/FileCreate.vue